<template>
  <div class="header-container themeable">
    <!-- logo -->
    <a href="#/org" style="display:flex;flex-direction:row;" @click="goToHome">
      <img class="logo" :src="orgImg" v-show="orgImg" :title="orgName">
      <span class="orgNameCss">
        {{orgName}}
      </span>
    </a>
    <!-- 搜索 -->
    <div class="topSearch" v-if="isBranch" >
      <Icon type="ios-search" size="20" @click="searchEnter" style="cursor:pointer;" />
      <Input  v-model="searchVal" placeholder="学员/客户/员工/班级/课程" 
        :maxlength="20"
        style="background: #424954;color:#fff;height:32px;width:250px;" 
        @on-change="searchChange"
        @on-enter="searchEnter"
        />
      <Icon type="md-close-circle" size="20" style="cursor:pointer;" @click="clearSearch" />
      <div class="tempList" v-show ="showTempUl && (stuList.length > 0 || custList.length > 0 || empList.length > 0 || classList.length > 0 || courseList.length > 0)">
        <ul v-show="stuList.length > 0">
          <li style="font-weight: 600;">学员</li>
          <template v-for="(item,index) in stuList">
            <li :key='"s"+ index' class="inPhone" v-if="index < 20" @click="jumpToResult(item,1)">
              <span>{{item.Name}}</span>
              <span>{{item.Phone}}</span>
            </li>
          </template>
        </ul>
        <ul v-show="custList.length > 0">
          <li style="font-weight: 600;">客户</li>
          <template v-for="(item,index) in custList">
            <li :key='"cu"+ index' class="inPhone" v-if="index < 20" @click="jumpToResult(item,2)">
              <span>{{item.Name}}</span>
              <span>{{item.Phone}}</span>
            </li>
          </template>
        </ul>
        <ul v-show="empList.length > 0">
          <li style="font-weight: 600;">老师</li>
          <template v-for="(item,index) in empList">
            <li :key='"em"+ index' class="inPhone" v-if="index < 20" @click="jumpToResult(item,3)">
              <span>{{item.Name}}</span>
              <span>{{item.Phone}}</span>
            </li>
          </template>
        </ul>
        <ul v-show="classList.length > 0">
          <li style="font-weight: 600;">班级</li>
          <template v-for="(item,index) in classList">
            <li :key='"cl"+ index' class="name" v-if="index < 20" @click="jumpToResult(item,4)">
              {{item.Name}}
            </li>
          </template>
        </ul>
        <ul v-show="courseList.length > 0">
          <li style="font-weight: 600;">课程</li>
          <template v-for="(item,index) in courseList">
            <li :key='"cl"+ index' class="name" v-if="index < 20" @click="jumpToResult(item,5)">
              {{item.Name}}
            </li>
          </template>
        </ul>
      </div>
    </div>
    <!-- 个人信息 -->
    <div class="info">
      <!-- 头像 -->
      <img class="avatar" src="../../assets/img/morenhead.png" alt>
      <!-- 姓名下拉菜单 -->
      <Dropdown trigger="click" :transfer="true">
        <a href="javascript:;">
          {{ userName }}
          <Icon type="ios-arrow-down" />
        </a>
        <DropdownMenu slot="list">
          <DropdownItem @click.native="goToMyService()" v-if="isShowMyService">
            <Icon type="md-ribbon" style="margin-right: 10px;"></Icon>
            <span>我的服务</span>
          </DropdownItem>
          <DropdownItem :divided="isShowMyService" @click.native="goToRouter()">
            <Icon type="md-lock" style="margin-right: 10px;"></Icon>
            <span>修改密码</span>
          </DropdownItem>
          <DropdownItem divided v-if="isShowPhone" @click.native="goToChangeUser()">
            <Icon type="md-phone-portrait" style="margin-right: 10px;"></Icon>
            <span>修改手机号</span>
          </DropdownItem>
          <DropdownItem divided @click.native="logOut">
            <Icon type="md-log-out" style="margin-right: 10px;"></Icon>
            <span>退出账号</span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>

      <!-- 通知和留言图标 -->
      <!-- <img @click="goToRouter('跳转通知')" class="tongzhi" src="../../assets/img/topatongzhi.png" alt="" title="通知">
      <img @click="goToRouter('跳转留言')" class="liuyan" src="../../assets/img/topaliuyan.png" alt="" title="留言">-->
      <!-- 校区切换下拉菜单 -->
      <template v-if="isBranch">
        <div class="btn-selbranch" @click="showBranchList=true">
          {{ currentBranchName }}
          <Icon type="chevron-down"></Icon>
        </div>
        <Tooltip v-if="HasOrgMenu" placement="bottom" content="返回机构" :delay="1000" style="cursor: pointer;">
          <div class="btn_goToOrg" @click="goToOrg">
            <img src="@/assets/img/arrow_back.png">
          </div>
        </Tooltip>
        <Drawer title="切换校区" v-model="showBranchList" :styles="branchStyle" width="360px">
          <p class="searchBrach-box">
            <Input v-model="keyword" placeholder="检索校区" />
          </p>
          <p class="branchItem" @click="goToBranch(item.OrgBranchId)" v-for="item in searchBranchResult"
            :key="item.OrgBranchId">{{item.Name}}</p>
        </Drawer>
      </template>
    </div>
  </div>
</template>

<script>
  import {
    mapGetters,
    mapState
  } from "vuex";
  import {
    app
  } from "../../base/config";
  var defaultImg = require(
    '@/assets/img/uploadimg.png');
  export default {
    data() {
      return {
        orgImg: undefined,
        orgName: '',
        // 校区列表
        keyword: "",
        branchStyle: {
          'background-color': '#EAEEF1',
          'padding': '0px'
        },
        showBranchList: false,
        searchVal: '',
        stuList: [],
        custList: [],
        empList: [],
        classList: [],
        courseList: [],
        showTempUl: false,
      };
    },
    computed: {
      //我的服务
      isShowMyService() {
        return !this.isBranch && this.checkBtnAuthority('btn_org_myservice', 'org_index');
      },
      isShowPhone(){
        return this.$store.state.userInfo.IsAdmin;
      },
      // 用户名
      userName() {
        return this.$store.state.userInfo.Name;
      },
      // 头像
      avatar() {
        return (
          this.$store.state.userInfo.PhotoPath || "../../assets/img/morenhead.png"
        );
      },
      isBranch() {
        return this.$store.state.currentRoot === "branch";
      },
      // 当前校区名称
      currentBranchName() {
        return this.currentBranch.Name;
      },
      ...mapState({
        currentBranch: "currentBranch",
        branchList: 'branchOrgList'
      }),
      ...mapGetters({
        HasOrgMenu: "checkHasOrgMenu",
        HasBranchMenu: "checkHasBranchMenu",
      }),
      searchBranchResult() {
        if (this.keyword) {
          return this.branchList.filter(i => i.Name.indexOf(this.keyword) > -1);
        }
        return this.branchList;
      }
    },
    watch: {
      searchVal() {
        this.searchChange();
      }
    },
    created() {

    },
    mounted() {
      this.GetOrgImg();
    },
    methods: {
      //跳转首页
      goToHome() {
        if (this.HasOrgMenu) {
          this.goToOrg();
        } else {
          let self = this;
          self.$store.commit('changeRoot', {
            root: 'branch',
            branchName: this.$store.state.currentBranch.Name,
            branchId: this.$store.state.currentBranch.OrgBranchId,
            callback() {
              self.$router.push("/branch");
              window.location.reload();
            }
          })
        }
      },
      //获取机构的图片
      GetOrgImg() {
        this.apiServer.organization._getModel().then(res => {
          if (res.code == 500) {
            this.$Message.warning(res.message);
          } else {
            if (res) {
              let imgUrl = res.LogoUrl ? this.staticConfig.addressConfig.fileServerDomain + res.LogoUrl +
                '?imageView2/1/w/150/' :
                defaultImg;
              this.orgImg = imgUrl;
              this.orgName = res.Name;
            }
          }
        })
      },
      // 返回home主页
      goToOrg() {
        let self = this;
        self.$store.commit('changeRoot', {
          root: 'org',
          callback() {
            self.$router.push("/org");
          }
        })

      },
      goToLink(url) {
        this.$router.push(url);
      },
      //跳转我的服务
      goToMyService() {
        this.$router.push('/org/myService');
      },
      // 根据路由跳转
      goToRouter(router) {
        this.$router.push('/login/changePwd');
      },
      goToChangeUser(){
        this.$router.push('/login/changePhone');
      },
      // 退出登录
      logOut() {
        this.$store.dispatch("removeUserInfo").then(() => {
          this.$router.push("/login");
        });

      },
      goToBranch(id) {
        let self = this;
        self.$Spin.show();
        let branch = self.searchBranchResult.find(x => x.OrgBranchId == id);
        self.$store.commit('changeRoot', {
          root: 'branch',
          branchName: branch.Name,
          branchId: branch.OrgBranchId,
          callback() {
            //self.$router.push('/branch');
            //self.$emit('home_reLoad');
            //self.$Spin.hide();
            window.location.reload();
          }
        })

      },
      // ----- 搜索 -------
      // 菜单权限
      menuShow(menuId) {
        let index = this.$store.state.menuList
            .findIndex((item) => item.ElementId == menuId);
        return index > -1;
      },
      searchChange() {
        if(!this.searchVal) {
          this.stuList = [];
          this.custList = [];
          this.empList = [];
          this.classList = [];
          this.courseList = [];
          return false;
        }
        this.apiServer.common._getNameSearchList({
            Search: this.searchVal,
            BranchId: this.$store.state.currentBranch.OrgBranchId,
            OrgId: this.$store.state.userInfo.OrgId
        }).then(res => {
            if (res.code == 500) {
                this.$Message.warning(res.message);
            } else {
                // Id
                this.stuList = res['1'] || [];
                this.custList = res['2'] || [];
                this.empList = res['3'] || [];
                this.classList = res['4'] || [];
                this.courseList = res['5'] || [];
                if(!this.menuShow('branch_educational_student')) {
                    this.stuList = [];
                }
                if(!this.menuShow('branch_customer_all')) {
                    this.custList = [];
                }
                if(!this.menuShow('branch_educational_classSchedule')) {
                    this.empList = [];
                }
                if(!this.menuShow('branch_educational_class')) {
                    this.classList = [];
                }
                if(!this.menuShow('branch_educational_course')) {
                    this.courseList = [];
                }
                this.showTempUl = this.stuList.length > 0 ||
                    this.custList.length > 0 ||
                    this.empList.length > 0 ||
                    this.classList.length > 0 ||
                    this.courseList.length > 0;
            }
        })
      },
      jumpToResult(item, index) {
        this.showTempUl = false;
        this.$router.push({
          name: 'branch_search',
          params: {
            content: item.Name,
            type: index,
            id: item.Id,
          }
        });
      },
      searchEnter() {
        if(!this.searchVal.trim()) {
          return false
        }
        this.showTempUl = false;
        this.$router.push({
          name: 'branch_search',
          params: {
            content: this.searchVal.trim()
          }
        });
      },
      clearSearch() {
        this.searchVal = '';
      }
    }
  };

</script>

<style lang="less" scoped>
  .headerMenu {
    float: left;
    background-color: transparent;
    color: #ffffff;
    margin-left: 220px;
  }

  .headerMenu.ivu-menu-horizontal {
    height: 60px;
    line-height: 60px;
  }

  .header-container {
    height: 50px;
    background-color: #292929;
    display: flex;
    flex-direction: row;
    z-index: 20;

    .logo {
      // height: 30px;
      // margin: 10px 30px;
      cursor: pointer;
      // position: absolute;
      // left: 0;
      height: 30px;
      margin: 10px 10px 10px 30px;
      // border-radius:50%;
    }

    .orgNameCss {
      display: inline-block;
      // color:#fff;
      // line-height:60px;
      display: inline-block;
      color: #fff;
      line-height: 50px;
      font-weight: bold;
      font-size: 16px;
    }

    .info {
      display: flex;
      justify-content: space-between;
      position: absolute;
      right: 0;
      top: 0;
      height: 30px;
      line-height: 30px;
      margin: 10px 20px 10px 0;

      .avatar {
        float: left;
        height: 30px;
        width: 30px;
        border-radius: 50%;
        margin-right: 10px;
      }

      a {
        display: inline-block;
        color: #fff;
        margin-right: 10px;
      }

      .tongzhi,
      .liuyan {
        cursor: pointer;
        margin-top: 5px;
        height: 30px;
        margin-right: 10px;
      }

      .ivu-btn-primary {
        background-color: pra;
        border: none;
        height: 100%;
      }
    }
  }

  .btn_goToOrg {
    width: 40px;
    border-radius: 3px;

    img {
      position: relative;
      top: 3px;
      left: 10px;
    }
  }

  .btn-selbranch {
    margin-left: 20px;
    margin-right: 10px;
    border-radius: 3px;
    color: #fff;
    padding: 0 10px;
    cursor: pointer;
  }

  .btn-selbranch .ivu-dropdown-rel {
    height: 100%;
  }

  .branchItem {
    font-size: 14px;
    color: #444;
    background: #fff;
    border-bottom: 1px solid #d8d8d8;
    min-height: 50px;
    line-height: 50px;
    padding: 0 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: keep-all;
    box-sizing: border-box;
    cursor: pointer;
  }

  .branchItem:hover {
    background-color: #ff5858;
    color: #fff;
    border-bottom: 1px solid #ffffff;
  }

  .searchBrach-box {
    height: 50px;
    margin-bottom: 10px;
    padding: 10px;
    background: #fff;
  }

  .currentbranch-info {
    line-height: 25px;
    background: #fff;
    padding: 10px 5px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: keep-all;
    box-sizing: border-box;
  }
// ---
.topSearch {
  background: #424954;
  color:#fff;
  padding: 0 10px;
  height: 34px;
  line-height: 32px;
  width: 320px;
  border-radius: 16px;
  margin-left: 50px;
  align-self: center;
  position: relative;
  .tempList {
    position: absolute;
    left: 0;
    // bottom: calc(~'-100% - 5px');
    color: #444;
    background: #fff;
    box-shadow: #eee 0px 0px 5px;
    border: 1px solid #eee;
    border-radius: 6px;
    display: flex;
    flex-direction: row;
    ul {
      padding: 10px 16px;
      border-right: 1px dashed #eee;
      &:last-child {
        border-right: 0;
      }
      li {
        list-style: none;
        cursor: pointer;
        &.name {
          width: 200px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        &.inPhone {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          width: 200px;
          text-align: justify;
          span:first-child {
            display: inline-block;
            width: 100px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/header/header.vue